import {Component, Input, OnInit} from "@angular/core";
import {FileSelectEvent} from "primeng/fileupload";
import {EmSchemaRuntimeDataDto} from "../../../../../../../em/model/dto/api/em-schema-runtime-data.dto";
import {ImSchemaFileService} from "../../../../../../service/api/im-schema-file.service";

@Component({
    selector: 'im-test-component',
    templateUrl: 'im-test.component.html',
    standalone: false
})

export class ImTestComponent implements OnInit {

    @Input() schemaFileId: number

    busy: boolean;

    emSchemaRuntimeDataDto: EmSchemaRuntimeDataDto;
    selectedFile: File;

    constructor(
        protected imSchemaFileService: ImSchemaFileService) {
    }

    ngOnInit() {

    }


    onFileSelect(event: FileSelectEvent) {
        this.selectedFile = event.files[0];
    }

    processDocument(fileUploader: any) {

        if (this.busy || !this.selectedFile ) {
            return;
        }

        this.busy = true

        this.imSchemaFileService.processFile(this.schemaFileId, this.selectedFile).subscribe(res => {
            this.emSchemaRuntimeDataDto = res;
            this.busy = false;
        }, error => {
            this.emSchemaRuntimeDataDto = null;
            this.busy = false;
        });
    }

    importDocument(fileUploader: any) {

        if (this.busy || !this.selectedFile ) {
            return;
        }

        this.busy = true

        this.imSchemaFileService.importFile(this.schemaFileId, this.selectedFile).subscribe(res => {
            this.busy = false;
        }, error => {
            this.emSchemaRuntimeDataDto = null;
            this.busy = false;
        });
    }

}